import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
export default hasSymbol ? Symbol["for"]('mui.nested') : '__THEME_NESTED__';